import React, { useMemo } from 'react';
import Modal from '../../../Atoms/Modal/Modal';
import TextInput from '../../../Atoms/Inputs/TextInput';
import Buttons from '../../../Atoms/Buttons/Buttons';
import ModalChildrenContainer from '../../../Atoms/Modal/ModalChildrenContainer';
import folder from '../../../../assets/Imagess/folderICon.svg';
import LoaderButton from '../../Loader/LoaderButton';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useSavePosition } from '../../../../Hooks/Settings';
import { useToast } from '../../Custom/CustomToaster/Toast';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const PositionsModal = ({ mode, selectedItem, handleOnClose, refetch }) => {
  const customizedToast = useToast();
  const { mutate: savePosition, isLoading } = useSavePosition();

  const positionId = useMemo(() => {
    if (mode === 'edit') return selectedItem?.positionId || selectedItem?.value;
    return EMPTY_GUID;
  }, [mode, selectedItem]);

  const initialValues = {
    positionAR:
      mode === 'edit'
        ? selectedItem?.positionAR ?? selectedItem?.text_AR ?? ''
        : '',
  };

  const validationSchema = Yup.object().shape({
    positionAR: Yup.string().required('Position AR is required'),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values) => {
        savePosition(
          {
            positionId,
            positionEN: values.positionAR,
            positionAR: values.positionAR,
          },
          {
            onSuccess: () => {
              customizedToast.open(
                mode === 'edit' ? 'تم التحديث بنجاح' : 'تمت الإضافة بنجاح'
              );
              refetch?.();
              handleOnClose();
            },
            onError: (e) => {
              console.error(e);
              customizedToast.open('حدث خطأ أثناء الحفظ');
            },
          }
        );
      }}
    >
      {({ values, errors, touched, setFieldValue, handleSubmit }) => {
        return (
          <Form>
            <Modal
              onClose={handleOnClose}
              title={mode === 'edit' ? 'تعديل منصب' : 'إضافة منصب'}
              width='40%'
              closeWhite={false}
            >
              <ModalChildrenContainer noOverflow>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                  }}
                >
                  <TextInput
                    label='المنصب'
                    icon={folder}
                    name='positionAR'
                    placeholder='ادخل المنصب '
                    value={values.positionAR}
                    required={true}
                    onChange={(name, value) => setFieldValue(name, value)}
                    errors={errors.positionAR}
                    touched={touched.positionAR}
                    left
                  />

                  {isLoading ? (
                    <LoaderButton />
                  ) : (
                    <div style={{ alignSelf: 'center', width: '30%' }}>
                      <Buttons
                        text={mode === 'edit' ? 'تحديث' : 'حفظ'}
                        handleOnClick={handleSubmit}
                        rounded
                      />
                    </div>
                  )}
                </div>
              </ModalChildrenContainer>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PositionsModal;
